import type {Content} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import type {Context} from 'src/common/types'
import {BentoGridHeroV2} from './BentoGrid'
import {BentoGridDynamicHeader} from './BentoGridDynamicHeader'
import {BentoGridHeroV2Reskin} from './BentoGridReskin'
import {DefaultHeroV2} from './DefaultHeroV2'
import {DefaultHeroV2WithLeadCapture} from './DefaultWithLeadCapture'
import {HeroV2FullWidthImage} from './FullWidthImage'
import {SideAssetDynamicHeaderHeroV2} from './SideAssetDynamicHeader'
import {SideAssetHeroV2} from './SideAssetHeroV2'
import {SideAssetVideoHero} from './SideAssetVideoHero'
import {VideoHero} from './VideoHero'

/**
 * Props for `HeroV2`.
 */
export type HeroV2Props = SliceComponentProps<Content.HeroV2Slice>

/**
 * Component for "HeroV2" Slices.
 */
const HeroV2 = ({
  slice,
  context: {pageUid, buttonsData, companyLogo, mainImage},
  index: componentIndex,
}: HeroV2Props & {context: Context}): JSX.Element => {
  switch (slice.variation) {
    case 'sideAsset':
      return (
        <SideAssetHeroV2 slice={slice} pageUid={pageUid} componentIndex={componentIndex} buttonsData={buttonsData} />
      )
    case 'sideAssetDynamicHeader':
      return (
        <SideAssetDynamicHeaderHeroV2
          slice={slice}
          pageUid={pageUid}
          componentIndex={componentIndex}
          buttonsData={buttonsData}
        />
      )
    case 'defaultWithLeadCapture':
      return <DefaultHeroV2WithLeadCapture slice={slice} pageUid={pageUid} componentIndex={componentIndex} />
    case 'video':
      return <VideoHero slice={slice} pageUid={pageUid} componentIndex={componentIndex} />
    case 'sideAssetVideo':
      return <SideAssetVideoHero slice={slice} pageUid={pageUid} componentIndex={componentIndex} />
    case 'bentoGrid':
      return (
        <BentoGridHeroV2 slice={slice} pageUid={pageUid} componentIndex={componentIndex} buttonsData={buttonsData} />
      )
    case 'bentoGridReskin':
      return (
        <BentoGridHeroV2Reskin
          slice={slice}
          pageUid={pageUid}
          componentIndex={componentIndex}
          buttonsData={buttonsData}
        />
      )
    case 'bentoDynamic':
      return (
        <BentoGridDynamicHeader
          slice={slice}
          pageUid={pageUid}
          componentIndex={componentIndex}
          buttonsData={buttonsData}
        />
      )
    case 'fullWidthImage':
      return (
        <HeroV2FullWidthImage
          slice={slice}
          pageUid={pageUid}
          componentIndex={componentIndex}
          companyLogoOverride={companyLogo}
          mainImageOverride={mainImage}
        />
      )
    default:
      return <DefaultHeroV2 slice={slice} pageUid={pageUid} componentIndex={componentIndex} buttonsData={buttonsData} />
  }
}

export default HeroV2
